// Define flags
export const DEFAULT_CHANNEL = true;
export const DEFAULT_CHANNEL_VALUE = 1;
export const MULTIPLE_CAT_PER_VIDEO = true;
export const SHOW_OVERVIEW_DASHBOARD = true;
export const SHOW_ADMIN_USERS = false;
export const SHOW_CONTENT_CATEGORIES = true;
export const SHOW_CONTENT_VIDEOS = true;

// Define commonly used constants
export const LS_ADMIN_USER_AUTH_TOKEN = '__tcls_admin_t';
export const LS_ADMIN_USER_NAME = '__tcls_admin_n';
export const LS_ADMIN_USER_EMAIL = '__tcls_admin_e';
export const LS_ADMIN_USER_ROLE = '__tcls_admin_r';

export const STATUS_LABELS = {
  0: 'Inactive',
  1: 'Active',
  2: 'Deleted',
  5: 'Requested Delete',
  11: 'Pending Verification',
  12: 'Cancellation Applied',
};

export const STATUS_COLORS = {
  0: 'error',
  1: 'success',
  2: 'error',
  5: 'warning',
  11: 'warning',
  12: 'warning',
};

// Valid admin roles
export const VALID_ADMIN_ROLES = {
  SUPER_ADMIN: 'SUPER_ADMIN',
  ADMIN: 'ADMIN',
  CONTENT_OWNER: 'CONTENT_OWNER',
};

export const CONTENT_ALIAS = {
  CHANNEL_SINGULAR: 'Channel',
  CHANNEL_PLURAL: 'Channels',
  CATEGORY_SINGULAR: 'Category',
  CATEGORY_PLURAL: 'Categories',
  ASSIGN_CATEGORY: 'Assign Category',
  VIDEO_SINGULAR: 'Video',
  VIDEO_PLURAL: 'Videos',
  SETTINGS: 'Settings',
};

export const ACTIONS = {
  CREATE: {
    value: 'create',
    label: 'Create New',
  },
  EDIT: {
    value: 'update',
    label: 'Edit',
  },
  VIEW: {
    value: 'view',
    label: 'View',
  },
  DELETE: {
    value: 'delete',
    label: 'Delete',
  },
  CHANGE_PASSWORD: {
    value: 'change_password',
    label: 'Change Password',
  },
  ASSIGN_CATEGORIES: {
    value: 'assign_categories',
    label: `Assign ${CONTENT_ALIAS.CATEGORY_PLURAL}`,
  },
  UPLOAD_MP4: {
    value: 'upload_mp4',
    label: 'Upload MP4',
  }
};

export const SESSION_TYPE = {
  video: 'Video',
  audio: 'Audio',
};

// Place it in CSS file
export const FOCUS_PALETTE_BGCOLOR = 'rgba(255, 255, 255, 0.25)';
